import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { option, selectData } from './selectData.model';

@Component({
  selector: 'gs-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  standalone: false,
})
export class SelectComponent implements OnInit {
  //------------------- INPUTS ---------------------------
  @Input() dropDownHeight: number = 200;
  @Input() selectDataParentChild: Array<selectData> = [];
  @Input() isParentChild: boolean = false;
  @Input() selectData: Array<option> = [];
  @Input() showAllCheckbox: boolean = false;
  @Input() allowMultiSelect: boolean = false;
  @Input() showSearch: boolean = false;
  @Input() searchPlaceholder: string = 'Search...';
  @Input() selectPlaceholder: string = 'Select Options';
  @Input() responsiveOptionHiding: boolean = true;
  @Input() hideOptionsAfter: number = 0;
  @Input() KeepParentChildSeparate: boolean = false;
  @Input() moduleToCheckParent: any;
  @Input() checkParents: any;
  @Input() disabled: boolean = false;
  @Input() parentExplicitSelection: boolean = false;

  //------------------------------------------------------

  //------------------- View Childs ---------------------------
  @ViewChild('selectContainer') selectContainer!: ElementRef;
  @ViewChild('outerSelectedTabsContainer')
  outerSelectedTabsContainer!: ElementRef;
  //-----------------------------------------------------------

  //---------- GLOBALS -----------------------------------
  showDD: boolean = false;
  allCheckBox: boolean = false;
  onlyChecked: Array<option> = [];
  /** Full list of checked items (before slicing for display). Used for dynamic width-based visible count. */
  allCheckedOptions: Array<option> = [];
  searchValue: string = '';
  clickWasSVG: boolean = false;
  removedTags: number = 0;
  /** Tracks how many real tags are shown when hideOptionsAfter is active (survives width-shrink passes). */
  private visibleTagCount = 0;
  /** Equal character limit applied to every visible tag label before "...". Null = show full names. */
  tagCharLimit: number | null = null;
  private readonly minVisibleTags = 2;
  /** Fixed character truncation length for visible chips when hideOptionsAfter is enabled. */
  private readonly fixedTagCharLimitWhenHidden = 10;
  //------------------------------------------------------

  //------------------------------------------------------
  @Output() DropDownChanged = new EventEmitter<any>();
  //------------------------------------------------------

  constructor() { }

  ngOnInit(): void {
    this.dropDownChanged(false);
    this.searchValueChanged();

    if (this.isParentChild) {
      for (let index = 0; index < this.selectDataParentChild.length; index++) {
        const pcData = this.selectDataParentChild[index];
        this.ChildrenChanged(index, 0, false);
      }
    }
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  showDropDown() {
    this.showDD = true;
    this.showHideDropDown();
  }

  toggleDropDown() {
    this.showDD = !this.showDD;
    this.showHideDropDown();
  }

  hideDropDown() {
    this.showDD = false;
    this.showHideDropDown();
  }

  showHideDropDown() {
    if (this.showDD) {
    } else {
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (this.selectContainer?.nativeElement.contains(event.target)) {
    } else {
      this.hideDropDown();
    }

    if (this.clickWasSVG) {
      this.showDropDown();
      this.clickWasSVG = false;
    }
  }

  @HostListener('window:resize')
  onResize() {
    if (this.hideOptionsAfter > 0 && this.allCheckedOptions.length > 0) {
      this.updateHideOptionsAfterByWidth();
    } else if (this.responsiveOptionHiding && this.allCheckedOptions.length > 0) {
      this.onlyChecked = [...this.allCheckedOptions];
      this.removedTags = 0;
      setTimeout(() => this.applyResponsiveHiding(), 10);
    }
  }

  dropDownChanged(emit: boolean = true) {
    //------------------ Changing All Checked Box -----------------------
    if (!this.isParentChild) {
      this.onlyChecked = this.selectData.filter(
        (x: option) => x.checked == true
      );
      if (this.onlyChecked.length == this.selectData.length) {
        this.allCheckBox = true;
      } else {
        this.allCheckBox = false;
      }
      this.allCheckedOptions = [...this.onlyChecked];
      if (emit) {
        this.DropDownChanged.emit(this.selectData);
      }
    }

    if (this.isParentChild) {
      let allSelectedLength = this.selectDataParentChild.filter(
        (x: selectData) => x.parent.checked == true
      )?.length;

      let totalParents = this.selectDataParentChild?.length;
      let totalChildren = 0;
      let totalCheckedChildren = 0;
      for (let index = 0; index < this.selectDataParentChild.length; index++) {
        totalChildren += this.selectDataParentChild[index].children.length;
        totalCheckedChildren += this.selectDataParentChild[
          index
        ].children.filter((x: option) => x.checked).length;
      }
      if (this.moduleToCheckParent != 'announcement') {
        if (
          totalChildren == totalCheckedChildren &&
          allSelectedLength == totalParents &&
          allSelectedLength > 0
        ) {
          this.allCheckBox = true;
        } else {
          this.allCheckBox = false;
        }
      } else {
        if (allSelectedLength == totalParents && allSelectedLength > 0) {
          this.allCheckBox = true;
        } else {
          this.allCheckBox = false;
        }
      }
      this.onlyChecked = [];

      this.selectDataParentChild.forEach((fullOption: selectData) => {
        fullOption.children.forEach((option: option) => {
          if (option.checked) {
            // Show "Parent: child" (e.g. Supplier: Rep) in the selected display
            this.onlyChecked.push({
              ...option,
              name: fullOption.parent.name + ': ' + option.name,
            });
          }
        });
      });
      this.allCheckedOptions = [...this.onlyChecked];
      if (emit) {
        this.DropDownChanged.emit(this.selectDataParentChild);
      }
    }
    this.removedTags = 0;
    this.tagCharLimit = null;
    // When hideOptionsAfter is set, show capped list immediately so we never paint the full list (avoids blink)
    if (this.hideOptionsAfter > 0 && this.allCheckedOptions.length > 0) {
      const total = this.allCheckedOptions.length;
      this.visibleTagCount = this.getEffectiveVisibleTagCount(total);
      this.applyVisibleTagCount();
    }
    this.UpdateOnlyCheckedAccordingToWidth();
    //-------------------------------------------------------------------
  }

  UpdateOnlyCheckedAccordingToWidth() {
    if (this.responsiveOptionHiding) {
      setTimeout(() => {
        if (this.allCheckedOptions.length > 0) {
          this.onlyChecked = [...this.allCheckedOptions];
          this.removedTags = 0;
          this.applyResponsiveHiding();
        }
      }, 10);
    } else if (this.hideOptionsAfter > 0) {
      this.updateHideOptionsAfterByWidth();
    }
  }

  private getSelectedContentWidth(): number {
    const outer = this.outerSelectedTabsContainer?.nativeElement;
    if (!outer) {
      return 0;
    }
    const tabs = outer.querySelector('.selectedTabsContainer') as HTMLElement | null;
    return tabs?.scrollWidth ?? outer.scrollWidth;
  }

  private getSelectedAvailableWidth(): number {
    const container = this.selectContainer?.nativeElement as HTMLElement | undefined;
    if (!container) {
      return 0;
    }
    const textBox = container.querySelector('.selectTextBoxData') as HTMLElement | null;
    return (textBox?.clientWidth ?? container.offsetWidth - 30) - 4;
  }

  private selectedContentOverflows(): boolean {
    return this.getSelectedContentWidth() > this.getSelectedAvailableWidth();
  }

  /** Always keep at least 2 visible tags when 2+ items are selected. */
  private getEffectiveVisibleTagCount(total: number): number {
    if (total <= 1) {
      return total;
    }
    if (this.hideOptionsAfter > 0) {
      return Math.min(total, Math.max(this.minVisibleTags, this.hideOptionsAfter));
    }
    return Math.min(total, this.minVisibleTags);
  }

  getDisplayName(option: option): string {
    if (option.id === 'G-Hide') {
      return option.name;
    }
    // For the "and N more..." UI, keep chip labels consistent for better layout.
    if (this.hideOptionsAfter > 0) {
      if (option.name.length <= this.fixedTagCharLimitWhenHidden) {
        return option.name;
      }
      return option.name.slice(0, this.fixedTagCharLimitWhenHidden) + '...';
    }

    if (this.tagCharLimit == null || option.name.length <= this.tagCharLimit) {
      return option.name;
    }
    return option.name.slice(0, this.tagCharLimit) + '...';
  }

  isDisplayTruncated(option: option): boolean {
    if (option.id === 'G-Hide') {
      return false;
    }
    return this.tagCharLimit != null && option.name.length > this.tagCharLimit;
  }

  getTagTooltip(option: option): string {
    if (option.id === 'G-Hide') {
      return '';
    }
    return option.name;
  }

  getMoreTooltip(): string {
    if (this.visibleTagCount >= this.allCheckedOptions.length) {
      return '';
    }
    return this.allCheckedOptions
      .slice(this.visibleTagCount)
      .map((item: option) => item.name)
      .join(', ');
  }

  hasMoreTooltip(): boolean {
    return this.getMoreTooltip().length > 0;
  }

  private applyVisibleTagCount() {
    const total = this.allCheckedOptions.length;
    this.onlyChecked = this.allCheckedOptions.slice(0, this.visibleTagCount);
    if (total > this.visibleTagCount) {
      this.onlyChecked.push({
        id: 'G-Hide',
        name: 'and ' + (total - this.visibleTagCount) + ' more...',
      });
    }
    this.onlyChecked = [...this.onlyChecked];
  }

  /** Used when responsiveOptionHiding is true: keep removing tags until content fits. */
  private applyResponsiveHiding() {
    if (this.onlyChecked.length === 0 || !this.outerSelectedTabsContainer?.nativeElement || !this.selectContainer?.nativeElement) {
      return;
    }
    const total = this.allCheckedOptions.length;
    const minVisible = this.getEffectiveVisibleTagCount(total);
    const visibleRealTags = this.onlyChecked.filter((item: option) => item.id !== 'G-Hide');
    const otherOption: option = { id: 'G-Hide', name: 'and ' };

    if (this.selectedContentOverflows()) {
      if (visibleRealTags.length > minVisible) {
        if (this.onlyChecked[this.onlyChecked.length - 1]?.id === 'G-Hide') {
          this.onlyChecked.pop();
        }
        this.onlyChecked.pop();
        this.removedTags++;
        otherOption.name = 'and ' + this.removedTags + ' more...';
        this.onlyChecked.push(otherOption);
        this.onlyChecked = [...this.onlyChecked];
        this.visibleTagCount = visibleRealTags.length - 1;
        setTimeout(() => this.applyResponsiveHiding(), 10);
        return;
      }

      this.visibleTagCount = visibleRealTags.length;
      this.adjustEqualTagTruncation();
    }
  }

  /**
   * Keep at least two visible tags, then shorten every tag label equally until content fits.
   */
  private updateHideOptionsAfterByWidth() {
    const total = this.allCheckedOptions.length;
    if (total === 0 || !this.outerSelectedTabsContainer?.nativeElement || !this.selectContainer?.nativeElement) {
      return;
    }

    this.visibleTagCount = this.getEffectiveVisibleTagCount(total);
    this.applyVisibleTagCount();
    // When hideOptionsAfter is enabled, we use fixed character truncation
    // (so short names like "Fund" never incorrectly become "Fun...").
  }

  private scheduleEqualTagTruncation() {
    setTimeout(() => {
      if (!this.outerSelectedTabsContainer?.nativeElement || !this.selectContainer?.nativeElement) {
        return;
      }

      if (!this.selectedContentOverflows()) {
        this.tagCharLimit = null;
        return;
      }

      this.adjustEqualTagTruncation();
    }, 10);
  }

  private adjustEqualTagTruncation(limit?: number) {
    const visibleTags = this.allCheckedOptions.slice(0, this.visibleTagCount);
    const maxNameLen = Math.max(0, ...visibleTags.map((item: option) => item.name.length));
    const nextLimit = limit ?? maxNameLen - 1;

    if (nextLimit < 0) {
      this.tagCharLimit = 0;
      return;
    }

    this.tagCharLimit = nextLimit >= maxNameLen ? null : nextLimit;

    setTimeout(() => {
      if (!this.outerSelectedTabsContainer?.nativeElement || !this.selectContainer?.nativeElement) {
        return;
      }

      if (this.selectedContentOverflows() && nextLimit > 0) {
        this.adjustEqualTagTruncation(nextLimit - 1);
      }
    }, 10);
  }

  updateChildrenCheckboxAccordingToParentAll() {
    this.selectDataParentChild.forEach((fullOption: selectData) => {
      this.setAllChildrenAsChecked(fullOption);
    });
    this.dropDownChanged();
  }

  updateChildrenCheckboxAccordingToParent(parentIndex: any) {
    this.setAllChildrenAsChecked(this.selectDataParentChild[parentIndex]);
    this.selectDataParentChild[parentIndex].parent.indeterminate = false;
    this.dropDownChanged();
  }

  setAllChildrenAsChecked(fullOption: selectData) {
    let index = this.selectDataParentChild.findIndex(
      (x: selectData) => x.parent.id == fullOption.parent.id
    );
    this.selectDataParentChild[index].children.map(
      (x: option) => (x.checked = fullOption.parent.checked)
    );
  }

  allCheckBoxChanged() {
    //------ selectData ---------
    if (!this.isParentChild) {
      this.selectData.map((x: option) => (x.checked = this.allCheckBox));
      this.dropDownChanged();
    }
    //---------------------------

    //------ selectDataParentChild ---------
    if (this.isParentChild) {
      this.selectDataParentChild.map((x: selectData) => {
        x.parent.checked = this.allCheckBox;
        x.parent.indeterminate = false; // Reset indeterminate state
      });
      this.checkParents = [];
      this.updateChildrenCheckboxAccordingToParentAll();
      this.dropDownChanged();
    }
    //---------------------------
  }

  removeFromSelected(option: option) {
    if (!this.isParentChild) {
      let index = this.selectData.findIndex((x: option) => x.id == option.id);
      if (index != -1) {
        this.selectData[index].checked = false;
      }
      this.dropDownChanged();
    }

    if (this.isParentChild) {
      let childIndex = -1;
      let parentIndex = -1;

      for (let index = 0; index < this.selectDataParentChild.length; index++) {
        const fullOption: selectData = this.selectDataParentChild[index];
        for (let index2 = 0; index2 < fullOption.children.length; index2++) {
          const optionIN: option = fullOption.children[index2];
          if (optionIN.id == option.id) {
            childIndex = index2;
            parentIndex = index;
          }
        }
      }
      this.checkParents = [];

      if (childIndex != -1 && parentIndex != -1) {
        this.selectDataParentChild[parentIndex].children[childIndex].checked =
          false;
        this.ChildrenChanged(parentIndex, childIndex);
      }
    }

    this.clickWasSVG = true;
  }
  removeAllSelected() {
    if (this.isParentChild) {
      this.selectDataParentChild.forEach((element) => {
        element.parent.checked = false;
        element.children.forEach((child) => {
          child.checked = false;
        });
      });
      this.checkParents = [];
    } else {
      this.selectData.forEach((element) => {
        element.checked = false;
      });
    }
    this.dropDownChanged();
    this.clickWasSVG = true;
  }

  changeChecked(option: option) {
    //------ selectData ---------
    if (!this.isParentChild) {
      let index = this.selectData.findIndex((x: option) => x.id == option.id);
      if (index != -1) {
        this.selectData[index].checked = !this.selectData[index].checked;
      }
      this.dropDownChanged();
    }
    //---------------------------
  }

  changeAllChecked() {
    this.allCheckBox = !this.allCheckBox;
    this.allCheckBoxChanged();
  }

  ChildrenChanged(
    parentIndex: number,
    childIndex: number,
    emitChanged: boolean = true
  ) {
    if (this.checkParents && this.checkParents.length) {
      let allChildrenChecked =
        this.checkIfAllChildrenAreCheckedEditUserModule(parentIndex);
      let someChildrenChecked = this.checkIfSomeChildrenAreChecked(parentIndex);

      this.selectDataParentChild = this.checkParents;

      if (this.parentExplicitSelection) {
        // When parentExplicitSelection is true, parent is never auto-checked
        // if (someChildrenChecked) {
        //   // Only set indeterminate if parent is not explicitly checked
        //   if (!this.selectDataParentChild[parentIndex].parent.checked) {
        //     this.selectDataParentChild[parentIndex].parent.indeterminate = true;
        //   } else {
        //     this.selectDataParentChild[parentIndex].parent.indeterminate = false;
        //   }
        // } else {
        //   // No children checked, uncheck parent and remove indeterminate
        //   this.selectDataParentChild[parentIndex].parent.checked = false;
        //   this.selectDataParentChild[parentIndex].parent.indeterminate = false;
        // }
        //if allChildrenChecked then indeterminate true

        if (allChildrenChecked && !this.selectDataParentChild[parentIndex].parent.checked && this.moduleToCheckParent != 'announcement') {
          this.selectDataParentChild[parentIndex].parent.indeterminate = true;
        } else {
          this.selectDataParentChild[parentIndex].parent.indeterminate = false;
        }
      } else {
        // Original behavior when parentExplicitSelection is false
        if (allChildrenChecked) {
          this.selectDataParentChild[parentIndex].parent.checked = true;
          this.selectDataParentChild[parentIndex].parent.indeterminate = false;
        }
        // else if (someChildrenChecked) {
        //   this.selectDataParentChild[parentIndex].parent.checked = false;
        //   this.selectDataParentChild[parentIndex].parent.indeterminate = true;
        // } 
        else {
          this.selectDataParentChild[parentIndex].parent.checked = false;
          this.selectDataParentChild[parentIndex].parent.indeterminate = false;
        }
      }
    } else {
      let allChildrenChecked = this.checkIfAllChildrenAreChecked(parentIndex);
      let someChildrenChecked = this.checkIfSomeChildrenAreChecked(parentIndex);

      if (this.parentExplicitSelection) {
        // When parentExplicitSelection is true, parent is never auto-checked
        // if (someChildrenChecked) {
        //   // Only set indeterminate if parent is not explicitly checked
        //   if (!this.selectDataParentChild[parentIndex].parent.checked) {
        //     this.selectDataParentChild[parentIndex].parent.indeterminate = true;
        //   } else {
        //     this.selectDataParentChild[parentIndex].parent.indeterminate = false;
        //   }
        // } else {
        //   // No children checked, uncheck parent and remove indeterminate
        //   this.selectDataParentChild[parentIndex].parent.checked = false;
        //   this.selectDataParentChild[parentIndex].parent.indeterminate = false;
        // }
        if (allChildrenChecked && !this.selectDataParentChild[parentIndex].parent.checked && this.moduleToCheckParent != 'announcement') {
          this.selectDataParentChild[parentIndex].parent.indeterminate = true;
        } else {
          this.selectDataParentChild[parentIndex].parent.indeterminate = false;
        }
      } else {
        // Original behavior when parentExplicitSelection is false
        if (allChildrenChecked) {
          this.selectDataParentChild[parentIndex].parent.checked = true;
          this.selectDataParentChild[parentIndex].parent.indeterminate = false;
        }
        // else if (someChildrenChecked) {
        //   this.selectDataParentChild[parentIndex].parent.checked = false;
        //   this.selectDataParentChild[parentIndex].parent.indeterminate = true;
        // } 
        else {
          this.selectDataParentChild[parentIndex].parent.checked = false;
          this.selectDataParentChild[parentIndex].parent.indeterminate = false;
        }
      }
    }

    if (emitChanged) {
      this.dropDownChanged();
    }
  }

  // Add this new method to check if some children are checked
  checkIfSomeChildrenAreChecked(parentIndex: number): boolean {
    let totalCheckedChildren = this.selectDataParentChild[
      parentIndex
    ].children.filter((x: option) => x.checked).length;
    return totalCheckedChildren > 0;
  }

  checkIfAllChildrenAreChecked(parentIndex: number): boolean {
    let totalChildren = this.selectDataParentChild[parentIndex].children.length;
    let totalCheckedChildren = this.selectDataParentChild[
      parentIndex
    ].children.filter((x: option) => x.checked).length;
    if (
      totalChildren == totalCheckedChildren
      && this.moduleToCheckParent == 'announcement'
    ) {
      return true;
    } else {
      return false;
    }
  }
  checkIfAllChildrenAreCheckedEditUserModule(parentIndex: number): boolean {
    this.selectDataParentChild[parentIndex].children;
    let totalChildren = this.selectDataParentChild[parentIndex].children.length;
    let totalCheckedChildren = this.selectDataParentChild[
      parentIndex
    ].children.filter((x: option) => x.checked).length;

    if (totalChildren == totalCheckedChildren) {
      return true;
    } else {
      return false;
    }
  }

  updateChildrenCheckboxAccordingToParentClick(parentIndex: number) {
    // this.selectDataParentChild[parentIndex].parent.checked =
    //   !this.selectDataParentChild[parentIndex].parent.checked;
    // this.updateChildrenCheckboxAccordingToParent(parentIndex);

    this.selectDataParentChild[parentIndex].parent.checked =
      !this.selectDataParentChild[parentIndex].parent.checked;

    this.setAllChildrenAsChecked(this.selectDataParentChild[parentIndex]);

    // Reset indeterminate state when parent is explicitly clicked
    if (this.selectDataParentChild[parentIndex].parent.checked) {
      this.selectDataParentChild[parentIndex].parent.indeterminate = false;
    }

    this.dropDownChanged();
  }

  ChildrenChangedClick(parentIndex: number, childIndex: number) {
    this.selectDataParentChild[parentIndex].children[childIndex].checked =
      !this.selectDataParentChild[parentIndex].children[childIndex].checked;
    this.ChildrenChanged(parentIndex, childIndex);
  }

  searchValueChanged() {
    if (!this.isParentChild) {
      this.selectData.map((option: option) => (option.search = false));
      if (this.searchValue.length == 0) {
        this.selectData.map((option: option) => (option.search = true));
      } else {
        this.selectData.map((option: option) => {
          if (
            option.name.toLowerCase().includes(this.searchValue.toLowerCase())
          ) {
            option.search = true;
          }
        });
      }
    }

    if (this.isParentChild) {
      this.selectDataParentChild.map(
        (fullOption: selectData) => (fullOption.parent['search'] = false)
      );
      this.selectDataParentChild.map((fullOption: selectData) =>
        fullOption.children.forEach((x: option) => (x.search = false))
      );

      if (this.searchValue.length == 0) {
        this.selectDataParentChild.map(
          (fullOption: selectData) => (fullOption.parent.search = true)
        );
        this.selectDataParentChild.map((fullOption: selectData) =>
          fullOption.children.forEach((x: option) => (x.search = true))
        );
      } else {
        this.selectDataParentChild.map((fullOption: selectData) =>
          fullOption.children.forEach((x: option) => {
            if (x.name.toLowerCase().includes(this.searchValue.toLowerCase())) {
              x.search = true;
            }
            if (
              fullOption.parent.name
                .toLowerCase()
                .includes(this.searchValue.toLowerCase())
            ) {
              fullOption.parent.search = true;
              fullOption.children.forEach((x: option) => (x.search = true));
            }
          })
        );

        this.selectDataParentChild.map((fullOption: selectData) => {
          if (
            fullOption.children.filter((x: option) => x.search == true).length >
            0 ||
            fullOption.parent.search == true
          ) {
            fullOption.parent.search = true;
          } else {
            fullOption.parent.search = false;
          }
        });
      }
    }
  }
}
